module.exports = __webpack_public_path__ + "static/BI-ba90efdb921dcc6dfdac1af6f898866e.jpg";